import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { enableLogin } from '../../../lib/fetch/profiles';
import UserPresentational from './UserPresentational';
import { useAuth } from '../../../commons/Auth';
import forgot from '../../../lib/fetch/forgot';
import { useLoading } from '../../../commons/Loading';
import axios from 'axios';

const User = (props) => {
  const [{ newToken } = {}] = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [t] = useTranslation();
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();

  const { profile, setProfile } = props;

  async function enable(requestData) {
    setIsLoading(true);
    const { active, email, password } = requestData;
    const { error, data: responseData } = await enableLogin({
      data: {
        _id: profile._id,
        active,
        email,
        password,
      },
      newToken,
    });

    setIsLoading(false);

    if (error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    if (active) {
      const { authId } = responseData;
      setProfile({
        ...profile,
        authEmail: email,
        authId,
      });
      alert.success(t('USERS:USER_ENABLED_SUCCESSFULLY'));
      return true;
    } else {
      setProfile({
        ...profile,
        authEmail: undefined,
        authId: undefined,
      });
      alert.success(t('USERS:USER_DISABLED_SUCCESSFULLY'));
    }
  }

  const forgotPassword = async () => {
    setIsLoading(true);
    const { authEmail } = profile;
    const { error } = await forgot(authEmail);
    setIsLoading(false);
    if (error) alert.error(t('COMMON:GENERIC_ERROR'));
    else alert.success(t('USERS:USER_FORGOT_SUCCESS'));
  };

  const onConfirmCancellation = async (cancellationDate) => {
    showLoading();

    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/profiles/${profile._id}`,
      {
        cancellationDate,
        type: profile.type,
        name: profile.name,
        businessName: profile.businessName,
        city: profile.city,
        address: profile.address,
        region: profile.region,
        district: profile.district,
        cap: profile.cap,
        fiscalCode: profile.fiscalCode,
        emailBilling: profile.emailBilling,
        sdiCode: profile.sdiCode,
        ...(profile.type === 'AGENCY' && { agencyType: profile.agencyType }),
      },
      {
        headers: { Authorization: newToken },
      }
    );

    if (response instanceof Error) {
      hideLoading();
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    hideLoading();
    alert.success(t('COMMON:SUCCESS_UPDATE'));
  };

  return (
    <UserPresentational
      data={profile}
      enable={enable}
      isLoading={isLoading}
      forgotPassword={forgotPassword}
      onConfirmCancellation={onConfirmCancellation}
      {...props}
    />
  );
};

export default User;
